<template>

    <div id="Language">

        <a @click="changeLocale('en')" :class="{active: geti18n().locale === 'en'}">

            ENG

        </a>

        <a @click="changeLocale('de')" :class="{active: geti18n().locale === 'de'}">

            GER

        </a>

		<a @click="changeLocale('zh')" :class="{active: geti18n().locale === 'zh'}">

            中文

        </a>

    </div>

</template>

<script>
    import Vue from 'vue'
    import FlagIcon from 'vue-flag-icon'
    import i18n from '@/plugins/i18n';
    import routes from "../../routes";

    Vue.use(FlagIcon);

    export default {
        methods: {
            changeLocale(locale) {
                i18n.locale = locale;
                document.querySelector('#Nav .Nav__icon').style.left = this.getRoute(this.$route.name).iconPosition[i18n.locale] + 'px';
            },
            geti18n () {
                return i18n;
            },
            getRoute (routeName) {
                for (let r of routes) {
                    if (r.name === routeName) {
                        return r;
                    }
                }

                return null;
            }
        }
    };
</script>
